<template>
  <div class="analysisreport-admTrackReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
      @handleColumnChange="handleColumnClick"
    >
      <div class="flex-wrap">
        <div class="flex-al mb10 mr10">
          <span class="mr10 fs14 color-666">{{
            $t("views.Analysisreport.admTrackReport.51nbh6yjwc22")
          }}</span>
          <div class="select-box">
            <el-date-picker
              v-model="filter.fixedtime"
              type="date"
              @change="search"
              value-format="yyyy-MM-dd"
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51nbh6yjwc33')
              "
              style="width:170px;"
            ></el-date-picker>
            <!-- <el-date-picker
              v-model="filter.rang_time"
              type="daterange"
              @change="search"
              :range-separator="$t('Report.analysisreport.admTrackReport.50zc0yief5g0')"
              value-format="yyyy-MM-dd"
              :start-placeholder="$t('Report.analysisreport.admTrackReport.50zc0yiefcg0')"
              :end-placeholder="$t('Report.analysisreport.admTrackReport.50zc0yiefiw0')"
              :picker-options="pickerOptions"
            ></el-date-picker>-->
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <!-- <span class="mr10 fs14 color-666">{{
            $t("views.Analysisreport.admTrackReport.51yzwntly2o0")
          }}</span> -->
          <div class="select-box" style="width:170px;">
            <el-select
              v-model="filter.coursetype_id"
              clearable
              filterable
              :placeholder="
                $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
              "
              @change="filterCourseCat"
            >
              <el-option
                v-for="(item, index) in filterList.coursetypeList"
                :key="index"
                :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                :value="item.coursetype_id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box" style="width:170px;">
            <el-select
              v-model="filter.coursecat_id"
              clearable
              filterable
              placeholder="请选择班种"
              @change="search"
            >
              <el-option
                v-for="(item, index) in filterList.courseCatList"
                :key="index"
                :label="`${item.coursecat_cnname}(${item.coursecat_branch})`"
                :value="item.coursecat_id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="ipt-box" style="width:280px;">
            <el-input
              v-model="filter.keyword"
              clearable
              placeholder="请输入学校名称、学校编号"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button type="primary" size="mini" class="search-btn fs14" @click="search">{{$t('views.Analysisreport.channelCrmDetailReport.51h4yx8fut40')}}</el-button>
        </div>
      </div>
      <!-- 校务招生追踪大表 -->
      <div class="inner-dialog dialog-list-details">
        <el-dialog
          :title="$t('views.Analysisreport.admTrackReport.51nbh6yjwcc0')"
          :visible.sync="showDetailPop"
          width="1100px"
        >
          <div class="list-details__header">
            <p class="name">
              <span
                >{{ $t("views.Analysisreport.admTrackReport.51nbhl1b3g00")
                }}{{ detailsData.schoolName }}</span
              >
              <span
                >{{ $t("views.Analysisreport.admTrackReport.51nbhl1b5f40")
                }}{{ detailsData.title }}</span
              >
            </p>
          </div>
          <div class="flex-wrap" style="padding: 0 20px 10px;">
            <div class="flex-al Inquire-box">
              <div class="ipt-box" style="width:400px;">
                <el-input
                  v-model="detailsData.keyword"
                  clearable
                  :placeholder="
                    query_field == 'positivelog_week_num' ||
                    query_field == 'positivelog_month_num'
                      ? $t('views.Analysisreport.admTrackReport.51z6mualrv80')
                      : $t('views.Analysisreport.admTrackReport.51nbh6yk0b40')
                  "
                  @clear="fliterSearch"
                  size="small"
                  @keyup.enter.native="fliterSearch"
                ></el-input>
              </div>
              <el-button
                type="primary"
                size="mini"
                class="search-btn fs14"
                @click="fliterSearch"
                >{{
                  $t("views.Analysisreport.admTrackReport.51nbh6yk0wk0")
                }}</el-button
              >
            </div>
          </div>
          <div class="list-details__content">
            <normalTableCont :tableData="tableList"></normalTableCont>
            <el-pagination
              style="padding: 20px 5px;"
              :current-page.sync="paging.curPage"
              :page-sizes="paging.sizeArray"
              :page-size.sync="paging.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="paging.total"
              @current-change="curPageChange"
              @size-change="pageSizeChange"
            ></el-pagination>
          </div>
        </el-dialog>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/tableTemplate";
import storeanalysisreport from "../analysisreport.js";
import normalTableCont from "@/components/tables/normalTableCont";

export default {
  name: "analysisreport-admTrackReport",
  data() {
    return {
      reportParams: {
        wayString: "getClientHighestReport", //传递到子组件的方法名称
        Title: this.$t("views.Analysisreport.admTrackReport.51nbh6yk1f00"),
      },
      //筛选
      filter: {
        // rang_time: "", //选择时间--必须定义为这个参数
        // start_time: "",
        // end_time: "",
        fixedtime: "", //学校id
        coursetype_id: "", //班组
        coursecat_id: "",
        type: 'admTrackReport',
        keyword: ''
      },
      // 筛选的下拉列表
      filterList: {
        schoolList: [], //选择学校-下拉数据
        coursetypeList: [], //班组-下拉数据
        courseCatList: [],
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
      // 查看招生详情
      showDetailPop: false,
      detailsData: {
        keyword: "",
      },
      sliderWidth: "500px",
      query_field:'',
      // 主表格数据
      tableList: {
        // 表格的列
        columns: [],
        // 表格数据
        list: [],
        options: {
          errortip: "", //空页面提示内容
          mutiSelect: false, //是否显示多选
          issetting: false, //是否可以编辑列
          tableHeight: 500,
        },
      },
      paging: {
        total: 0,
        curPage: 1,
        pageSize: 10,
        sizeArray: [10, 20, 30, 40],
      },
    };
  },
  components: {
    reportPageTemp,
    normalTableCont,
  },
  updated() {},
  created() {
    this.filter.fixedtime = this.$Common.getDateStr3(new Date());
    this.courseTypeRecruitApi();
    this.getTypeCourseCatApi();
    // this.filter.rang_time = [
    //   this.$Common.getMonthStartAndEnd(0)[0],
    //   this.$Common.getDate(0)
    // ];
    // (this.filter.start_time = this.$Common.getMonthStartAndEnd(0)[0]),
    //   (this.filter.end_time = this.$Common.getDate(0));
  },
  computed: {},
  watch: {
    showDetailPop(n) {
      if (!n) {
        this.paging.curPage = 1;
        this.paging.pageSize = 10;
      }
    },
  },
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeRecruitApi() {
      this.$http.courseTypeRecruitApi({
        coursetype_isrecruit: 1
      }).then((res) => {
        if (res.data.code === 200) {
          this.filterList.coursetypeList = res.data.data.list;
        } else {
          this.filterList.coursetypeList = [];
        }
      });
    },
    filterCourseCat() {
      this.filter.coursecat_id = "";
      this.getTypeCourseCatApi();
      this.search()
    },
    getTypeCourseCatApi() {
      this.$http
        .getTypeCourseCatApi({
          coursetype_id: this.filter.coursetype_id,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.courseCatList = data.list;
          } else {
            this.filterList.courseCatList = [];
          }
        });
    },
    //检索
    search() {
      // this.filter.start_time = this.filter.rang_time
      //   ? this.filter.rang_time[0]
      //   : "";
      // this.filter.end_time = this.filter.rang_time
      //   ? this.filter.rang_time[1]
      //   : "";
      this.$refs.reportPageTemp.search();
    },
    // 关闭招生详情
    hideDetailBox() {
      this.showDetailPop = false;
    },
    // 招生详情筛选
    fliterSearch() {
      this.paging.curPage = 1;
      this.getReportClientListApi();
    },
    getReportClientListApi() {
      storeanalysisreport
        .getReportClientListApi({
          school_id: this.school_id,
          query_field: this.query_field,
          p: this.paging.curPage,
          num: this.paging.pageSize,
          keyword: this.detailsData.keyword,
          fixedtime: this.filter.fixedtime,
          coursetype_id: this.filter.coursetype_id,
          coursecat_id: this.filter.coursecat_id,
        })
        .then((res) => {
          var d = res.data;
          var r = d.result || {};
          var t =
            d.all_num != null
              ? d.all_num
              : d.allnum != null
              ? d.allnum
              : r.all_num != null
              ? r.all_num
              : r.allnum != null
              ? r.allnum
              : 0;
          this.tableList.list = r.list ? r.list : [];
          this.tableList.columns = r.field;
          this.paging.total = Number(t) || 0;
          this.tableList.options.errortip = d.msg;
        });
    },
    handleColumnClick(v1, v2, v3) {
      (() => {})(v1, v2, v3);
      this.query_field = v2.fieldstring;
      this.school_id = v3.school_id;
      this.detailsData.title = v2.fieldname;
      this.detailsData.schoolName = v3.school_shortname;
      this.showDetailPop = true;
      this.detailsData.keyword = ''
      this.getReportClientListApi();
    },
    curPageChange(v) {
      this.paging.curPage = v;
      this.getReportClientListApi();
    },
    pageSizeChange(v) {
      this.paging.curPage = 1;
      this.paging.pageSize = v;
      this.getReportClientListApi();
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   if (this.$refs["auto_height_table"]) {
    //     this.tableList.options.tableHeight = this.$Tool.getTableHeight(
    //       this.$refs.auto_height_table.getBoundingClientRect().top + 75
    //     );
    //   }
    // });
  },
};
</script>
<style lang="less">
.analysisreport-admTrackReport {
  .el-main {
    margin-bottom: 0px;
  }
  // 中间弹框样式
  .dialog-list-details {
    .list-details__header {
      padding: 15px 20px;
      font-size: 18px;
      color: #333;
      .name {
        span {
          margin-right: 50px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .list-details__content {
      padding: 0 20px 20px 20px;
    }
    &.inner-dialog {
      .el-dialog__body {
        padding: 0;
      }
      .el-dialog {
        .el-dialog__header {
          padding: 12px;
        }
      }
    }
  }
}
</style>
